module.exports = __webpack_public_path__ + "static/img/instant-money.4a51eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instant-money.svg
// module id = 0cTh
// module chunks = 1